import { render, staticRenderFns } from "./publicTryForFree.vue?vue&type=template&id=4edbcd90&scoped=true"
import script from "./publicTryForFree.vue?vue&type=script&lang=js"
export * from "./publicTryForFree.vue?vue&type=script&lang=js"
import style0 from "./publicTryForFree.vue?vue&type=style&index=0&id=4edbcd90&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4edbcd90",
  null
  
)

export default component.exports